import { subscriptionApi } from "./services/resourceGroups/subscriptionApi";


interface IApiConfig {
    alarmApiUrl,
    alarmHubUrl,
    alarmClassesApiUrl,
    resourceGroupApiUrl,
    qRCodeUrl,
    objectsApiUrl,
    objectsTemplateApiUrl,
    objectRelationsUrl,
    objectsHubUrl,
    historicalDataApi,
    objectClassesApiUrl,
    dashboardApiUrl,
    bacnetStateApi,
    subscriptionApiUrl,
    tenantAPiUrl,
    userAPiUrl,
    notificationsAPiUrl,
    subscriptionPortalUrl,
    energyMetersApiUrl,
    schedulersApiUrl,
    heatmapApiUrl,
    userInteractionsApiUrl,
    isDevelopment: boolean,
    apiBaseUrl: string,
}

const ENV = process.env;
export const IsDevelopment = ENV.REACT_APP_DEVELOPMENT === '1'
const backendUrl = ENV.REACT_APP_BACKEND_URL;
const bacnetMappingBackendUrl = ENV.REACT_APP_BACKEND_MAPPING_BACNET_API_URL;
const bacnetStateBackendUrl = ENV.REACT_APP_BACKEND_MAPPING_BACNET_STATE_API_URL;
const alarmBackendUrl = ENV.REACT_APP_BACKEND_ALARM_API_URL;
const alarmHubBackendUrl = ENV.REACT_APP_BACKEND_ALARM_HUB_URL;
const historyBackendUrl = ENV.REACT_APP_BACKEND_HISTORY_API_URL;
const resourceGroupBackendUrl = ENV.REACT_APP_BACKEND_RESOURCEGROUP_API_URL;
const dashboardApiUrl = ENV.REACT_APP_BACKEND_DASHBOARDS_URL;
const objectsHubUrl = ENV.REACT_APP_BACKEND_OBJECTS_HUB_URL;
const alarmClassesBackendUrl = ENV.REACT_APP_BACKEND_ALARM_CLASSES_URL;
const notifBackendUrl = ENV.REACT_APP_BACKEND_NOTIFICATIONS_API_URL;
const objectsTemplateBackendApiUrl = ENV.REACT_APP_BACKEND_OBJECTS_TEMPLATES_API_URL;
const apimUrl = ENV.REACT_APP_APIM_URL

// API Endpoints **************************************************************
export const apiConfig: IApiConfig = {
    alarmApiUrl: `${alarmBackendUrl}/alarms`,
    alarmHubUrl: `${alarmHubBackendUrl}/alarmshub/`,
    alarmClassesApiUrl: `${alarmClassesBackendUrl}/alarmClasses`,
    qRCodeUrl: `${backendUrl}/QRCode`,
    objectsApiUrl: `${backendUrl}/`,
    objectsTemplateApiUrl: `${objectsTemplateBackendApiUrl}/`,
    objectRelationsUrl: `${backendUrl}/v2/objectrelations`,
    objectsHubUrl: `${objectsHubUrl}/objectshub`,
    historicalDataApi: `${historyBackendUrl}/`,
    objectClassesApiUrl: `${backendUrl}/objectclasses`,
    dashboardApiUrl: `${dashboardApiUrl}/dashboards`,
    bacnetStateApi: `${bacnetStateBackendUrl}/bacnetstate`,
    resourceGroupApiUrl: `${resourceGroupBackendUrl}/`,
    subscriptionApiUrl: `${resourceGroupBackendUrl}/subscriptions`,
    tenantAPiUrl: `${resourceGroupBackendUrl}/tenants`,
    userAPiUrl: `${resourceGroupBackendUrl}/`,
    notificationsAPiUrl: `${notifBackendUrl}/`,
    energyMetersApiUrl: ENV.REACT_APP_BACKEND_ENERGY_METERS_API_URL,
    schedulersApiUrl: ENV.REACT_APP_BACKEND_SCHEDULERS_API_URL,
    isDevelopment: ENV.REACT_APP_DEVELOPMENT === '1',
    subscriptionPortalUrl: ENV.REACT_APP_SUBSCRIPTION_ADMIN_URL,
    heatmapApiUrl: `${apimUrl}/v3.0/heatmap`,
    userInteractionsApiUrl: `${apimUrl}/userinteractions`,
    apiBaseUrl: `${apimUrl}`
    
}


// **************************************************************

export const mapsKey = ENV.REACT_APP_BINGMAPS_KEY;




// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/" //Enter_the_Graph_Endpoint_Here/v1.0/me"
};
